'use client';
import Button from '@repo/ui/src/components/Button';
import LoadingLogo from '@components/Loading/LoadingLogo';
import { prependSlash } from '@repo/ui/src/components/Anchor/helpers';
import { useCustomer } from '@hooks/customer';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import React from 'react';

const Unauthed = () => {
  const { t } = useTranslation();
  const { push } = useModal(ModalID.login);
  const { isLoading } = useCustomer();

  const redirect = prependSlash(
    t('account.landingPage.link.link', undefined, { default: '/account/order-history' }),
  );
  return (
    <div className="tw-px-5 md:tw-px-14 lg:tw-px-20 tw-max-w-body tw-mx-auto">
      <article className="tw-px-6 tw-py-10 md:tw-px-0 tw-grid tw-gap-12">
        <div className="tw-grid tw-gap-6">
          <h2 className="tra-text-web-heading-2 tw-text-center" tabIndex={0}>
            {t('account.unauthed.header', undefined, { default: 'My Account' })}
          </h2>
          <hr className="tw-border-2 tw-w-12 tw-border-brand-300 tw-mx-auto" />
        </div>
        {isLoading ? (
          <LoadingLogo />
        ) : (
          <div className="tw-border-warm-400 tw-border tw-bg-warm-100 tw-p-10 tw-grid tw-gap-6 tw-justify-items-center">
            <p className="tw-text-center tra-text-web-body-l tw-font-bold">
              {t('account.unauthed.subtitle', undefined, {
                default:
                  'You are not currently logged in. Please do so in order to access your account',
              })}
            </p>
            <Button onClick={() => !isLoading && push({ redirect })}>
              {t('account.unauthed.buttonText', undefined, { default: 'Log In' })}
            </Button>
          </div>
        )}
      </article>
    </div>
  );
};

export default Unauthed;
